module.exports = __webpack_public_path__ + "fonts/VvXUGKZXbHtX_S_VCTLpGhkAz4rYn47Zy2rvigWQf6w.woff2";